var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "evidence" }, [
    _c("header", [
      _vm.videoUrl
        ? _c("i", {
            staticClass: "el-icon-arrow-left icon",
            on: {
              click: function($event) {
                _vm.videoUrl = null
              }
            }
          })
        : _c("i", { staticClass: "el-icon-arrow-left icon" }),
      _c("p", [_vm._v("拍证据")])
    ]),
    _vm.videoUrl
      ? _c("div", { staticClass: "main" }, [
          _c("video", {
            attrs: { src: _vm.videoUrl, controls: "controls", width: "100%" }
          })
        ])
      : _c("div", { staticClass: "main" }, [
          _c("div", { staticClass: "list-sign" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "sign-item" },
              [
                _c("ul", { staticClass: "list-cel" }, [
                  _c("li", [
                    _vm.evidenceFront
                      ? _c("img", {
                          attrs: {
                            src: _vm.showImg(_vm.evidenceFront.thumbnailImg),
                            alt: ""
                          }
                        })
                      : _c("img", {
                          attrs: { src: "/images/m/identity-1.png", alt: "" }
                        })
                  ]),
                  _c(
                    "li",
                    [
                      _vm.evidenceFront
                        ? [
                            _c("b", [
                              _vm._v(_vm._s(_vm.evidenceFront.updateTimeFmt))
                            ]),
                            _c("br"),
                            _c("small", [
                              _vm._v(_vm._s(_vm.evidenceFront.updateTimeSecond))
                            ]),
                            _vm._v(" 证件正面\n            ")
                          ]
                        : _c("b", [_vm._v("正面手持证件示例")])
                    ],
                    2
                  ),
                  _c(
                    "li",
                    { staticClass: "text-right" },
                    [
                      _vm.evidenceFront
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "danger", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.delEvidence(
                                    _vm.evidenceFront.evidenceId
                                  )
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        : _c(
                            "el-upload",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "margin-left": "15px"
                              },
                              attrs: {
                                action: "",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.handleImgClick0,
                                accept: "image/*"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "trigger",
                                    type: "success",
                                    size: "small"
                                  },
                                  slot: "trigger"
                                },
                                [_vm._v("添加")]
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                ]),
                _c("ul", { staticClass: "list-cel" }, [
                  _c("li", [
                    _vm.evidenceReverse
                      ? _c("img", {
                          attrs: {
                            src: _vm.showImg(_vm.evidenceReverse.thumbnailImg),
                            alt: ""
                          }
                        })
                      : _c("img", {
                          attrs: { src: "/images/m/identity-2.png", alt: "" }
                        })
                  ]),
                  _c(
                    "li",
                    [
                      _vm.evidenceReverse
                        ? [
                            _c("b", [
                              _vm._v(_vm._s(_vm.evidenceReverse.updateTimeFmt))
                            ]),
                            _c("br"),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.evidenceReverse.updateTimeSecond)
                              )
                            ]),
                            _vm._v(" 证件背面\n            ")
                          ]
                        : _c("b", [_vm._v("证件背面示例")])
                    ],
                    2
                  ),
                  _c(
                    "li",
                    { staticClass: "text-right" },
                    [
                      _vm.evidenceReverse
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "danger", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.delEvidence(
                                    _vm.evidenceReverse.evidenceId
                                  )
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        : _c(
                            "el-upload",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "margin-left": "15px"
                              },
                              attrs: {
                                action: "",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.handleImgClick1,
                                accept: "image/*"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "trigger",
                                    type: "success",
                                    size: "small"
                                  },
                                  slot: "trigger"
                                },
                                [_vm._v("添加")]
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                ]),
                _vm._l(_vm.videoSignInfo, function(item, i) {
                  return _vm.videoSignInfo && _vm.videoSignInfo.length
                    ? _c("ul", { key: i, staticClass: "video-sign" }, [
                        _c("li", { staticClass: "logo" }),
                        _c("li", { staticClass: "cont" }, [
                          item.signNames
                            ? _c("b", [_vm._v(_vm._s(item.signNames))])
                            : _vm._e(),
                          item.duration
                            ? _c("p", [
                                _vm._v(
                                  "时长：" +
                                    _vm._s(_vm._f("secToTime")(item.duration))
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                }),
                _vm.evidenceInfo
                  ? _vm._l(_vm.evidenceInfo, function(item, i) {
                      return _c("ul", { key: i, staticClass: "list-cel" }, [
                        _c(
                          "li",
                          [
                            item.evidenceVideoUrl
                              ? [
                                  _c("img", {
                                    staticClass: "play-video",
                                    attrs: { src: "/images/m/play.png" },
                                    on: {
                                      click: function($event) {
                                        return _vm.playVideo(
                                          item.evidenceVideoUrl
                                        )
                                      }
                                    }
                                  })
                                ]
                              : _vm._e(),
                            item.thumbnailImg
                              ? _c("img", {
                                  attrs: {
                                    src: _vm.showImg(item.thumbnailImg),
                                    alt: ""
                                  }
                                })
                              : _c("img", { attrs: { src: item.url, alt: "" } })
                          ],
                          2
                        ),
                        _c(
                          "li",
                          [
                            item.url
                              ? [_vm._v("正在上传")]
                              : [
                                  _c("b", [_vm._v(_vm._s(item.updateTimeFmt))]),
                                  _c("br"),
                                  _c("small", [
                                    _vm._v(_vm._s(item.updateTimeSecond))
                                  ])
                                ]
                          ],
                          2
                        ),
                        _c(
                          "li",
                          { staticClass: "text-right" },
                          [
                            item.evidenceId
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "danger", size: "small" },
                                    on: {
                                      click: function($event) {
                                        return _vm.delEvidence(item.evidenceId)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    })
                  : _vm._e()
              ],
              2
            )
          ]),
          _c("p", { staticClass: "remark" }, [
            _vm._v("备注:请根据需求选择添加图片或视频,大小不超过30MB。")
          ])
        ]),
    _c("div", { staticClass: "footer" }, [
      _c("ul", { staticClass: "navbar" }, [
        _c("li", { staticStyle: { position: "relative" } }, [
          _c("input", {
            staticClass: "btn btn-primary btn-lg btn-block",
            staticStyle: {
              position: "absolute",
              width: "100%",
              height: "100%",
              opacity: "0",
              "z-index": "999",
              top: "0",
              left: "0"
            },
            attrs: {
              type: "file",
              capture: "camera",
              accept: "image/*",
              id: "cameraInput",
              name: "cameraInput"
            },
            on: { change: _vm.handleImgClick2 }
          }),
          _c("i", { staticClass: "icon icon-addimage" }),
          _vm._v("\n        添加图片\n      ")
        ]),
        _c("li", { staticStyle: { position: "relative" } }, [
          _c("input", {
            staticClass: "btn btn-primary btn-lg btn-block",
            staticStyle: {
              position: "absolute",
              width: "100%",
              height: "100%",
              opacity: "0",
              "z-index": "999",
              top: "0",
              left: "0"
            },
            attrs: {
              type: "file",
              capture: "camcorder",
              accept: "video/*",
              id: "videoInput",
              name: "videoInput"
            },
            on: { change: _vm.uploadEvidenceVideo }
          }),
          _c("i", { staticClass: "icon icon-addvideo" }),
          _vm._v("\n        添加视频\n      ")
        ]),
        _c(
          "li",
          { staticClass: "bg-danger", on: { click: _vm.uploadFinish } },
          [_vm._v(" 完成 ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sign-item" }, [
      _c("h3", { staticClass: "text-center" }, [_vm._v("温馨提示")]),
      _c("p", [
        _vm._v("可选择上传"),
        _c("span", { staticClass: "color-danger" }, [_vm._v("图片")]),
        _vm._v("或"),
        _c("span", { staticClass: "color-danger" }, [_vm._v("视频")]),
        _vm._v("证据，若不需要请直接返回 ")
      ]),
      _c("p", [
        _vm._v("图片：（如单据、房本信息），视频：（如签署录像、卸货过程）")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8df8431c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8df8431c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/m/evidence.vue
// module id = g9vl
// module chunks = 206